import baseUrl from "../Api/baseUrl";
import notify from "./useNotifaction";

const useInsertDataWithImage = async (url, params) => {
  const config = {
    headers: {
      "content-type": "multipart/form-data",
      token: `${localStorage.getItem("token")}`,
    },
  };
  const res = await baseUrl.post(url, params, config);
  return res;
};

const useInsertData = async (url, params) => {
  const config = {
    headers: {
      "content-type": "application/json",
      token: `${localStorage.getItem("token")}`,
    },
  };
  try {
    const res = await baseUrl.post(url, params, config);
    return res;
  } catch (error) {
    // console.log(error);
    // notify(error.message || error.response, "error");
    console.error("Error in useInsertData:", error.response || error.message);
    throw error;
  }
};

export { useInsertData, useInsertDataWithImage };
